import { Link } from "react-router-dom";

interface Props {
  tag?: string;
  title: string;
  sub?: string;
  more?: { to: string; label: string };
  align?: "left" | "center";
  size?: "md" | "lg";
}

export default function SectionHeading({ tag, title, sub, more, align = "left", size = "md" }: Props) {
  return (
    <div className={align === "center" ? "text-center" : ""}>
      {tag && (
        <span className="mb-2 inline-block whitespace-nowrap rounded-sm bg-primary-500 px-2 py-0.5 font-label text-xs tracking-widest text-background-50">
          {tag}
        </span>
      )}
      <div className="flex items-end justify-between gap-4">
        <div>
          <h2
            className={`rule-title rule-${align === "center" ? "left" : "right"} ${
              size === "lg" ? "text-2xl md:text-3xl" : "text-xl md:text-2xl"
            } font-heading font-black text-foreground-950`}
          >
            {title}
          </h2>
          {sub && <p className="mt-2 max-w-2xl text-sm leading-6 text-foreground-600">{sub}</p>}
        </div>
        {more && (
          <Link
            to={more.to}
            className="mb-1 hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-600 sm:flex"
          >
            {more.label}
            <i className="ri-arrow-right-line"></i>
          </Link>
        )}
      </div>
    </div>
  );
}